<template src= "./index.html"></template>

<script>
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'
import {ko} from 'vuejs-datepicker/dist/locale'
import { Tag } from 'element-ui'
import moment from 'moment'
import agTableComp from '@/optionData/agTableComp'

export default {
  name: 'artistList',
  
    data () {
        return {
            ko : ko,
            optionData : optionData,
           
            keywordOption :[
                {value: 'ref_code', label:'내부이관 코드'},
                {value: '_email', label:'이메일'},
                {value: '_company', label:'회사명'},
                {value: '_name', label:'권리자명'},
                {value: '_lid', label:'LID'},
            ],
            keywordType :'ref_code',
            keyword : '',
          
            startDate :null,
            endDate : null,
            dateType :'created_at' ,
            dateOption : [
                {value: 'created_at',label: '등록일',},
            ],
            total : 0,
            filtered:0,
            page: {
                pageSize : 50,
                currentPage: 1,                       // 현재 페이지
                totalPage: 0,                         // 총 페이지수
            },          
            gridOptions :{ // 테이플 옵션
                onRowClicked: (event)=>{
                    //this.viewDetail(event)
                },
                frameworkComponents : {
                    btnSelect : agTableComp.btnSelect,
                },
                context: {
                    componentParent: this
                },
                getRowHeight:(params)=>{
                    console.log(params)
                    return 80;
                }
            },
            defaultColDef: {
                sortable: false,
                editable: false,
                resizable: true,
                suppressMenu: false,
                rowSelection:'single'
            },
            
            columnDefs: [
                {headerName: '내부이관코드', field: 'ref_code', filter: false,width: 130,
                    cellRendererParams: {
                        clicked: function(data) {
                            this.context.componentParent.viewDetail(data.id);
                        },
                    },
                    cellRendererSelector: (data) => {
                        let dd={
                            component: 'btnSelect',
                            params: {
                                ...data.data,
                                title: data.value
                            }
                        } ;
                        // if(this.selectTrack.track_id ==  data.data.track_id ){
                        //     dd.params['disabled'] = true
                        //     dd.params['title'] = '선택완료'
                        // }
                        
                        return dd
                    }
                },
                
                {headerName: '상태',      field: 'state',     filter: false,width: 100, cellRenderer: (data) => {
               
                    let text = {
                        'pending' : '작업대기', 
                        'processing' : '작업중', 
                        'transfer_success' : '이관성공', 
                        'transfer_failed' : '이관실패'
                    }
                     let color = {
                        'pending' : '#529adb', 
                        'processing' : '#a457ad', 
                        'transfer_success' : '#239351', 
                        'transfer_failed' : '#f9383f'
                    }
                     let t = data.value
                    return `<div class="cellCenter"><span class="textCenter" style=" min-width:80px; color:#fff; padding: 3px 8px; border-radius:8px; background : ${color[t]}">${text[t]}</span></div>`
                }},
                {headerName: '등록일',      field: 'created_at',     filter: false,width: 130,
                cellRenderer: (data) => {
                    return `<div class="cellCenter"><span>${this.fixDate(data.value)}</span></div>`
                }},
                
                {headerName: '이관대상',  field: 'album_count',  filter: false,width: 180,cellRenderer: (data) => {
                    let t = this.numberFilter(data.value) + ' 앨범 / ' + data.data.track_count + ' 트랙'
                    
                    return `<div class="cellCenter"><span>${t}</span></div>`
                }},
                {headerName: 'From(양도)',  field: 'old_licensor',  filter: false,width: 300,cellRenderer: (data) => {
                    let t = data.value.user.email
                    let name = `${(data.value.family_name ? data.value.family_name : '')} ${(data.value.given_name ? data.value.given_name : '')}`
                    var pattern3 = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; //한글
                    if(pattern3.test(name)){
                        name = `${(data.value.family_name ? data.value.family_name : '')} ${(data.value.given_name ? data.value.given_name : '')}`
                    }else{
                        name = `${(data.value.given_name ? data.value.given_name : '')} ${(data.value.family_name ? data.value.family_name : '')}` 
                    }
                    
                    let company = data.value.company ? data.value.company : ''
                        return  `
                        <div class="cellCenter">
                            <span>
                                    ${t} 
                                    <br/>
                                    ${name } ${name && company?  '/ ' :'' }  ${ company}
                            </span>
                        </div>`
                }},
                {headerName: 'To(양수)',  field: 'new_licensor',  filter: false,width: 300,cellRenderer: (data) => {
                    let t = data.value.user.email
                    let name = `${(data.value.family_name ? data.value.family_name : '')} ${(data.value.given_name ? data.value.given_name : '')}`
                    var pattern3 = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; //한글
                    if(pattern3.test(name)){
                        name = `${(data.value.family_name ? data.value.family_name : '')} ${(data.value.given_name ? data.value.given_name : '')}`
                    }else{
                        name = `${(data.value.given_name ? data.value.given_name : '')} ${(data.value.family_name ? data.value.family_name : '')}` 
                    }
                    
                    let company = data.value.company ? data.value.company : ''
                        return  `
                        <div class="cellCenter">
                        <span>
                            ${t} 
                            <br/>
                            ${name } ${name && company?  '/ ' :'' }  ${ company}
                        </span>
                        </div>`
                }},
                {headerName: '메모',      field: 'description',     filter: false,width: 400, cellRenderer: (data) => {
                    return `<div class="cellCenter"><span class="text3line">${data.value? data.value : ''}</span></div>`
                    
                }},
                {headerName: '등록자',      field: 'user.admin_nickname',     filter: false,width: 200, cellRenderer: (data) => {
                    return `<div class="cellCenter"><span>${data.value}</span></div>`
                }},
                
                
            ],
            tableData:[
            ],       
            
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage= Number(this.$route.query.page)
        }
        if(this.$route.query.keywordType){
            this.keywordType= this.$route.query.keywordType
        }
        if(this.$route.query.keyword){
            this.keyword= this.$route.query.keyword
        }
        if(this.$route.query['date_field']) this.dateType = this.$route.query['date_field'] 
        if(this.$route.query['date_start'] && this.$route.query['date_end'] ) {
            this.startDate = this.$route.query['date_start'] 
            this.endDate = this.$route.query['date_end'] 
        }
        
      
    },
    mounted(){
        this.$nextTick(() =>{
        this.callList()
        })
    },
    watch: {
        'page.currentPage'(e){
            
            this.callList()
        },
        'page.pageSize'(){
            this.list_search()
        }
    },
    methods: {
        resetSearch (){
            this.page.currentPage = 1
            this.keywordType = null
            this.keyword = ''
            this.dateType = null
            this.startDate = null
            this.endDate = null
            this.callList() 
        },
        callList(){
            const option = {
                sort : 'created_at',
                sortorder: 'desc',
                page: this.page.currentPage-1 ,
                limit: this.page.pageSize,
            }
            let query = {
                
            }
            if(this.page.currentPage != 1){
                query['page'] = this.page.currentPage
            }
            if(this.keywordType && this.keyword != '') {
                option[this.keywordType] = this.keyword
                query['keywordType'] = this.keywordType
                query['keyword'] = this.keyword 
            }
           
            
            
            if( !this.valCheck(this.startDate ) && !this.valCheck(this.endDate) ){
                //option['date_field'] = this.dateType
                option['date_start'] = this.startDate
                option['date_end'] = this.endDate
                // if(this.dateType !== 'registered_at' ){
                //     option['sort'] = this.dateType +',registered_at'
                // }else{
                //     option['sort'] = this.dateType
                // }
                
                //query['date_field'] = this.dateType
                query['date_start'] = this.startDate
                query['date_end'] = this.endDate
            }else{
                delete option['date_start'] 
                delete option['date_end'] 
                delete query.date_start
                delete query.date_end
            }
            console.log(query)
            this.$router.replace({query: query}).catch((e)=>{});
            this.loadingShow()
            this.$store.dispatch('GET_TRANSFER_LIST', option)
            .then(result =>{
                this.loadingHide()
                console.log(result)
                this.tableData  = result.items // 권리자 목록
                
                this.total = result.total // 총인원수 
                this.filtered = result.filtered // limit에 따른 수
                //페이지 수
                const remainder = parseInt(this.filtered % this.page.pageSize) > 0? 1: 0
                this.page.totalPage = parseInt(this.filtered/this.page.pageSize) + remainder
            }).catch(error=>{
                this.loadingHide()
                const status = error.status
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                    this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        
        list_search(){
            this.page.currentPage = 1  // 초기화
            this.callList()
        },
        viewDetail(event){
            this.$router.push('transfer/detail/'+event)
        },

    }
}
</script>

<style scoped>

</style>
